import axios from "axios";
import authService from "../services/auth/auth.service";
import { apiUrl } from "../services/api/urls";

axios.defaults.baseURL = apiUrl();

// get token from browser storage and set
const personalToken = authService.getToken();
if (personalToken)
  axios.defaults.headers.common["Authorization"] = "Token " + personalToken;

// set token manually
export const setApiCallsAuth = (token: string) => {
  axios.defaults.headers.common["Authorization"] = "Token " + token;
};
